<div class="user-select">
  <div class="user-content" v-if="!$slots.default" :class="{'disabled':disabled}">
    <div class="user-list"  @click="showModal">
      <span v-if="!selectedRoles.length" >请选择</span>
      <template v-else>
        <a-tag
          :disabled="disabled"
          v-for="role in selectedRoles"
          :key="role.id"
          :closable="!disabled"
          color="blue"
          @close.prevent="deleteSelectedUser(role.id)"
        >
        <span v-if="role.name.length<10">
          {{ role.name }}
        </span>
          <a-tooltip v-else :title="role.name" class="append-to-body" >
            {{role.name.slice(0,9)+'...'}}
          </a-tooltip>
        </a-tag>
      </template>
    </div>
    <div
      class="add-icon"
      v-if="selectedRoles.length < maxCount"
      type="link"
      @click="showModal"
    >
      <img src="../../assets/images/icon_add.png" />
    </div>
  </div>

  <span v-if="$slots.default" @click="showModal">
    <slot></slot>
  </span>

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    class="user-select-modal user-mod"
    width="820px"
    @cancel="cancelFn"
    @ok="ok"
  >
    <template #title>
      <span>选择角色</span>
      <small v-if="maxCount && maxCount !== Infinity">本次操作最多可选 {{ maxCount }} 个角色</small>
    </template>
    <div class="user-select-modal__bd">
      <a-tabs v-model:activeKey="activeKey">
        <!-- <a-tab-pane key="1" tab="项目内角色">Content of Tab Pane 1</a-tab-pane> -->
        <a-tab-pane key="2" tab="组织内角色" force-render>
          <table-wrapper
          ref="tableRef"
          :dataSource="rolesData"
          @onSelectionChange="onSelectionChange"
          :tableHeight="500"
          :loading="loading"
          :columns="columns"
        >
        </table-wrapper>
        </a-tab-pane>
       
      </a-tabs>
    </div>
  </a-modal>
</div>
